import {jsxs as _jsxs, jsx as _jsx} from "react/jsx-runtime";import {useEffect} from 'react'
import useAtmosphere from '../hooks/useAtmosphere'
import useDocumentTitle from '../hooks/useDocumentTitle'
import useMutationProps from '../hooks/useMutationProps'
import useRouter from '../hooks/useRouter'
import AcceptTeamInvitationMutation from '../mutations/AcceptTeamInvitationMutation'
import {LocalStorageKey} from '../types/constEnums'
import getTokenFromSSO from '../utils/getTokenFromSSO'
import {emitGA4SignUpEvent} from '../utils/handleSuccessfulLogin'
import DialogContent from './DialogContent'
import DialogTitle from './DialogTitle'
import Ellipsis from './Ellipsis/Ellipsis'
import InvitationDialogCopy from './InvitationDialogCopy'
import InviteDialog from './InviteDialog'
import StyledError from './StyledError'





const TeamInvitationSSO = (props) => {
  const {ssoURL} = props
  const {onCompleted, submitMutation, onError, error} = useMutationProps()
  const atmosphere = useAtmosphere()
  const {history} = useRouter()
  useEffect(() => {
    const loginWithSAML = async () => {
      const invitationToken = localStorage.getItem(LocalStorageKey.INVITATION_TOKEN)
      submitMutation()
      const response = await getTokenFromSSO(ssoURL)
      if ('error' in response) {
        onError(new Error(response.error || 'Error logging in'))
        return
      }
      const {token, ga4Args} = response
      atmosphere.setAuthToken(token)
      emitGA4SignUpEvent(ga4Args)
      AcceptTeamInvitationMutation(atmosphere, {invitationToken}, {history, onCompleted, onError})
    }
    loginWithSAML().catch(() => {
      /*ignore*/
    })
  }, [])
  useDocumentTitle('SSO Login | Team Invitation', 'Team Invitation')

  return (
    _jsxs(InviteDialog, { children: [
      _jsx(DialogTitle, { children: "SSO Login" })
      , _jsxs(DialogContent, { children: [
        !error && (
          _jsxs(InvitationDialogCopy, { children: ["Logging in to your secure SSO Provider"

            , _jsx(Ellipsis, {} )
          ]})
        )
        , error && _jsx(StyledError, { children: error.message})
      ]})
    ]})
  )
}

export default TeamInvitationSSO
